var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlazaveaMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plazavea-mobile",
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3909 15.5786C45.9247 15.1929 44.3918 15 42.8589 15C36.1941 15 28.3296 19.6933 23.0644 27.1512C20.3318 31.0087 19.6654 32.8731 19.6654 32.8731C19.732 31.0087 19.6654 29.1442 19.3321 27.344C19.0655 25.9296 18.5323 25.5439 17.7992 25.351C16.7329 25.1581 15.6665 25.5439 15 26.3154C15.8664 27.2155 16.3996 28.3727 16.4663 29.5943C16.6662 31.7802 16.7995 34.0304 16.7328 36.2163C16.7328 36.7306 16.5996 36.9878 17.0661 36.9878H19.5321C19.932 37.0521 20.3318 36.8592 20.5318 36.4735C21.4649 34.2233 24.1974 28.887 27.4632 25.6082C32.995 20.0791 37.6603 18.2146 42.7256 18.2146C45.1249 18.2146 46.7244 18.5361 47.7908 19.179C48.7905 18.7289 49.2571 17.5717 48.8572 16.6073C48.5239 16.093 47.9908 15.7072 47.3909 15.5786Z",
    fill: "#FFE016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlazaveaMobile);
export default __webpack_public_path__ + "static/media/plazavea_mobile.c5d5d0b47462efcbcb398ab76ff69017.svg";
export { ForwardRef as ReactComponent };